import { API_REQUEST, GET_PROFILE_DETAILS, RESET_GET_PROFILE_DETAILS, SAVE_RESULT, UPDATE_ACKNOWLEDGEMENT_FLAG } from "../../actionTypes/actionsTypes"
import { AppAction, LocalAction } from "../../types"

export const getProfileDetails = (snapshotId: number | string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/profile-details/${snapshotId}`,
    next: GET_PROFILE_DETAILS,
    method: 'GET',
    authorization: true
  }
})

export const putContactInfo = (snapshotId: string | number, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/contact-info/${snapshotId}`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
})

export const putFiscalDetails = (snapshotId: string | number, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/fiscal-details/${snapshotId}`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
})

export const putCommercialFlag = (snapshotId: string | number, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/comm-flag/${snapshotId}`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
})

export const putPieAnalysis = (snapshotId: string | number, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/pie-analysis/${snapshotId}`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
})

export const putAcknowledgementFlag = (new_flag: boolean, snapshotId: string | number): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/update-acknowledgement/${snapshotId}`,
    next: UPDATE_ACKNOWLEDGEMENT_FLAG,
    method: 'POST',
    data: {
      "acknowledgementFlag": new_flag,
      "snapshotId": snapshotId
    },
    authorization: true
  }
});

export const putAptFlagAffordableHousing = (snapshotId: string | number, payload: Record<string, unknown>): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/apartment/${snapshotId}`,
    data: {
      ...payload
    },
    next: SAVE_RESULT,
    method: 'PUT',
    authorization: true
  }
});

export const resetGetProfileDetails = (): LocalAction => ({
  type: RESET_GET_PROFILE_DETAILS
})